import React, { useState, useRef, useEffect } from "react";

const ScannerPage = () => {
  const [scannedCodes, setScannedCodes] = useState([]);
  const inputRef = useRef(null);
  const defaultText = "Сканируйте код";

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = defaultText; // Устанавливаем дефолтный текст при загрузке
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const handleGlobalKeyDown = () => {
      if (inputRef.current && document.activeElement !== inputRef.current) {
        inputRef.current.focus();
      }
    };

    document.addEventListener("keydown", handleGlobalKeyDown);
    return () => {
      document.removeEventListener("keydown", handleGlobalKeyDown);
    };
  }, []);

  useEffect(() => {
    if (!inputRef.current) return;
    const input = inputRef.current;

    const handleInput = () => {
      if (input.value.trim() === "") {
        input.value = defaultText; // Если пусто, подставляем дефолтное значение
      }
    };

    const handleKeyPress = (e) => {
      if (e.key === "Enter") {
        setTimeout(() => {
          input.value = defaultText; // Восстанавливаем текст после ввода
        }, 100);
      }
    };

    input.addEventListener("input", handleInput);
    input.addEventListener("keypress", handleKeyPress);

    return () => {
      input.removeEventListener("input", handleInput);
      input.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const value = inputRef.current.value.trim();
      if (value !== "" && value !== defaultText) {
        setScannedCodes((prev) => [...prev, value]);
        inputRef.current.value = defaultText; // Очищаем и возвращаем дефолтный текст
      }
    }
  };

  const handleFocus = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.setSelectionRange(9999, 9999);
      }
    }, 100);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Тест сканера iData K2</h1>

      <input
        type="text"
        inputMode="none"
        
        
        
        id="barcodeInput"
        placeholder={defaultText}
        style={{ width: "100%", padding: "8px", fontSize: "16px" }}
      />
       <input
        type="text"
        
        style={{ width: "100%", padding: "8px", fontSize: "16px" }}
      />
      <input
        type="text"
        
        style={{ width: "100%", padding: "8px", fontSize: "16px" }}
      />


      <h2>Отсканированные коды:</h2>
      {scannedCodes.length === 0 ? (
        <p>Коды отсутствуют</p>
      ) : (
        <ul>
          {scannedCodes.map((code, index) => (
            <li key={index} style={{ marginBottom: "8px" }}>
              {code}{" "}
              <button
                onClick={() =>
                  setScannedCodes((prev) =>
                    prev.filter((_, i) => i !== index)
                  )
                }
              >
                Удалить
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ScannerPage;
